module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gu-72d014175a36d7caf81eb7a6551cb9df.svg";